var cmd = false;
var notClickRecent = true;
var rangeFontColor = false;
var oFontColor = false;
var oFontColorEnd = false;
var oFontTarget = false;
var fontAction = false;

(function ($) {
    RVwys.plugin['StandardWordButton'] = true;
    RVwys.plugin['StandardWordButton'] = {};
    RVwys.plugin['StandardWordButton']['dynamic'] = true;
    RVwys.addButtonStarteByTags('bold', 'strong');
    RVwys.addButtonStarteByTags('italic', 'em');
    RVwys.addButtonStarteByTags('bold', 'b');
    RVwys.addButtonStarteByTags('italic', 'i');
    RVwys.addButtonStarteByTags('underline', 'u');
    RVwys.addButtonStarteByTags('strikethrough', 'strike');
    RVwys.addButtonStarteByTags('superscript', 'sup');
    RVwys.addButtonStarteByTags('subscript', 'sub');
    RVwys.standardwordEnable = function () {
        parent.$('body').find('.standardword').removeAttr('disabled');
    };
    RVwys.standardwordDisable = function () {
        parent
            .$('body')
            .find('.standardword')
            .each(function () {
                if ($(this).attr('id') != undefined) {
                    if (!$(this).attr('id').match(/_ena/gi)) {
                        $(this).attr(
                            'id',
                            $(this).attr('id').replace('_dis', '') + '_ena'
                        );
                    }
                }
            });
        parent.$('body').find('.standardword').attr('disabled', 'disabled');
    };
    $(document).bind('editorReady', function () {
        $('.standardword').click(function (e) {
            if (!$(this).attr('id').match(/_ena/gim)) {
                var oNotactiveTag = {};
                oNotactiveTag['h6'] = true;
                oNotactiveTag['h5'] = true;
                oNotactiveTag['h4'] = true;
                oNotactiveTag['h3'] = true;
                oNotactiveTag['h2'] = true;
                oNotactiveTag['h1'] = true;
                if (RVwys.currentEditor) {
                    var range = RVwys.getRange();
                    if (document.all && !range.text) {
                        $(RVwys.currentiFrame).focus();
                        RVwys.execDesignMode($(this).attr('cmd'), false, '');
                    } else {
                        RVwys.execDesignMode($(this).attr('cmd'), false, null);
                    }
                    RVwys.switchButtonStarte($(this));
                }
            }
        });

        // RemoveFormatting

        $('.clean,.mini_clean').click(function () {
            var ru = RVwys.currentEditor.getSelection();
            var aAt = ru.getRangeAt(0);
            var str = aAt;
            var content = aAt.startContainer;
            var endcontent = aAt.endContainer;
            var parentTag = $(content).parent();
            //content
            if (parentTag.attr('style') != '') {
                parentTag.removeAttr('style');
            }
            RVwys.execDesignMode('formatBlock', false, null);
            RVwys.execDesignMode('removeFormat', false, null);
            RVwys.execDesignMode('unlink', false, null);
            RVwys.activeEventButtonStarte();

            /*
			 if($.browser.msie){
				 RVwys.execDesignMode("formatBlock", false, null);
				 RVwys.execDesignMode("removeFormat", false, null);
				 RVwys.execDesignMode("unlink", false, null);
				 RVwys.activeEventButtonStarte();
			 } else {
				 var ru = RVwys.currentEditor.getSelection();
				 var aAt = ru.getRangeAt(0);
				 var str = aAt
				 var content = aAt.startContainer;
				 var endcontent = aAt.endContainer;
				 var parentTag = $(content).parent();
				 //content
				 if (parentTag.attr('style') !='') {
					 parentTag.removeAttr('style')
				 }
				 RVwys.execDesignMode("formatBlock", false, null);
				 RVwys.execDesignMode("removeFormat", false, null);
				 RVwys.execDesignMode("unlink", false, null);
				 RVwys.activeEventButtonStarte();
			 }
			  */
        });

        //	 ColorFormatting

        $('.fontcolor,.mini_fontcolor').spectrum({
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'hex',
            beforeShow: function () {
                fontAction = $(this).attr('cmd');
                rangeFontColor = false;
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);

                $(RVwys.currentiFrame).bind('keydown', RVwys.unkeydown);
            },
            move: function (color) {
                RVwys.setFontColor(color);
            },

            hide: function (color) {
                RVwys.setFontColor(color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
                $(RVwys.currentiFrame).unbind('keydown', RVwys.unkeydown);
                if (rangeFontColor != '') {
                    RVwys.selectRange(rangeFontColor);
                }
                $(RVwys.currentiFrame).focus();
                if (oFontColor) {
                    oFontColor.removeClass('borderColor');
                }
                rangeFontColor = false;
                oFontColor = false;
            },
        });
    });

    RVwys.setmaxlength = function (event) {
        var max_chars = 2;
        if (event.value.length > max_chars) {
            event.value = event.value.substr(0, max_chars);
        }
    };

    RVwys.setStyleToALink = function () {};
    // ColorFormatting
    RVwys.unkeydown = function () {
        return false;
    };
    RVwys.setFontColor = function (color) {
        // if (color == null) return false;
        cmd = fontAction;

        var oNotactiveTag = {};
        oNotactiveTag['h6'] = true;
        oNotactiveTag['h5'] = true;
        oNotactiveTag['h4'] = true;
        oNotactiveTag['h3'] = true;
        oNotactiveTag['h2'] = true;
        oNotactiveTag['h1'] = true;
        if (RVwys.currentEditor) {
            //hiliteColor

            /*
			 if(!$.browser.msie && cmd == 'backcolor') {
				 cmd = 'HiliteColor';
			 }
			 */
            var sel = RVwys.currentEditor.getSelection();
            console.log('check range select' + rangeFontColor);
            if (!rangeFontColor) {
                //RVwys.execDesignMode(cmd, false,  color);
                var fo = $('#frameBody').get(0).contentWindow;
                fo.RVwys.history.add();
                rangeFontColor = RVwys.getRange(); // this range use start
                if (rangeFontColor != '') {
                    RVwys.execDesignMode(cmd, false, color);
                    rangeFontColor = RVwys.getRange(); // ***this range required override range after set execDesignMode
                    oFontColor = $(rangeFontColor.startContainer).parent();
                    sel.removeAllRanges();
                } else {
                    rangeFontColor = RVwys.getRange();
                    if (rangeFontColor.startContainer) {
                        if (oFontColor) {
                            if (fontAction == 'ForeColor') {
                                oFontColor
                                    .parents('font')
                                    .attr('color', color)
                                    .find('a')
                                    .css({
                                        color: color.toHexString(),
                                    });
                                oFontColor.attr('color', color);
                                oFontColor.find('font').attr('color', color);
                            } else {
                                oFontColor
                                    .parents('font,ol,ul,li')
                                    .css({
                                        backgroundColor: color.toHexString(),
                                    })
                                    .find('a')
                                    .css({
                                        backgroundColor: color.toHexString(),
                                    });
                                oFontColor.css({
                                    backgroundColor: color.toHexString(),
                                });
                                oFontColor.find('font').css({
                                    backgroundColor: color.toHexString(),
                                });
                            }
                            oFontColor.addClass('borderColor');
                        } else {
                            console.log('this range' + color);
                            RVwys.execDesignMode(cmd, false, color);
                            rangeFontColor = false;
                        }
                    }
                }
            } else {
                console.log('this rangeFontColor' + color);
                if (color) {
                    console.log('case has object');
                    console.log(oFontColor.get(0));

                    RVwys.selectRange(rangeFontColor);
                    RVwys.execDesignMode(cmd, false, color);
                } else {
                    if (fontAction == 'ForeColor') {
                        oFontColor.removeAttr('color');
                    } else {
                        oFontColor.css('backgroundColor', '');
                    }

                    RVwys.selectRange(rangeFontColor);

                    /*  RVwys.execDesignMode("formatBlock", false, null);
					 RVwys.execDesignMode("removeFormat", false, null);
					 RVwys.execDesignMode("unlink", false, null); */

                    rangeFontColor = false;
                    // sel.removeAllRanges();
                }
                //RVwys.selectRange(rangeFontColor);
            }

            if (color) {
                if (fontAction == 'ForeColor') {
                    $(rangeFontColor.startContainer).parent().find('a').css({
                        color: color.toHexString(),
                    });
                } else {
                    $(rangeFontColor.startContainer)
                        .parent()
                        .find('a')
                        .css('backgroundColor', color.toHexString());
                }
            }

            RVwys.setStyleToALink();
        }
    };

    //dtbarimage|dtbartable|dtbartablecellprop
    // do not use this case by tanawat
    $(document).bind('mouseup_dtbartext', function () {
        setTimeout(function () {
            // RVwys.standardwordEnable();
        }, 50);
    });
    $(document).bind('mouseup_dtbartable', function () {
        setTimeout(function () {
            // RVwys.standardwordEnable();
        }, 50);
    });
    $(document).bind('mouseup_dtbarimage', function (e) {
        setTimeout(function () {
            // RVwys.standardwordDisable();
        }, 50);
    });
    $(document).bind('mouseup_dtbartablecellprop', function () {
        setTimeout(function () {
            // RVwys.standardwordDisable();
        }, 50);
    });

    RVwys.designViewAddEvent('mousedown', function (e) {
        if ($(e.target).get(0).tagName.toLowerCase() == 'font') {
            console.log('e target color' + $(e.target).attr('color'));
            if ($(e.target).attr('color')) {
                parent
                    .$('.fontcolor,.mini_fontcolor')
                    .spectrum('set', $(e.target).attr('color'));
            }
            if ($(e.target).css('color')) {
                parent
                    .$('.fontcolor,.mini_fontcolor')
                    .spectrum('set', $(e.target).attr('color'));
            }
            //parent.oFontTarget = $(e.target);
        }
    });
})(jQuery);
